const React = require('react');
import HttpsProtocolImage from '../../../component/common/https-protocol-image';
import FormattedMessage from '@/intl/formatted-message';
import { formatMessage } from '../../../intl/helper';
import shoppingCartMessages from '../../../intl/messages/shopping-cart';
import orderText from '../../../intl/messages/order';
import actionText3 from '../../../intl/messages/action/part3';

import { SiglePrivTypes, INDUSTRY } from '../../../helper/const.js';
const helper = require('../../../helper/dish-helper');

const Toast = require('../../mui/toast');
const BookButton = require('../../book/book-button.jsx');
const formatPrice = require('../../../helper/common-helper.js').formatPrice;
const sellType = JSON.parse(localStorage.basicListInfo || '{}').way || 'ws';
const classnames = require('classnames');
const defaultCartIcon = require('../../../asset/images/cart-icon.svg');
const defaultCartIconTea = require('../../../asset/images/tea-cart-icon.svg');
const defaultCartIconHas = require('../../../asset/images/cart-icon-has.svg');
const defaultCartIconHasTea = require('../../../asset/images/tea-cart-icon-has.svg');
import { getIndustryFromBody } from '../../../helper/industry-helper';

module.exports = React.createClass({
  displayName: 'TinyCart',
  propTypes: {
    expand: React.PropTypes.bool,
    tinyRemainEnable: React.PropTypes.bool,
    dishesCount: React.PropTypes.number.isRequired,
    totalPrice: React.PropTypes.number,
    totalMemberPrice: React.PropTypes.number,
    takeawayServiceProps: React.PropTypes.object,
    isShopOpen: React.PropTypes.bool.isRequired,
    urlType: React.PropTypes.string,
    isAcceptOrder: React.PropTypes.bool,
    isEnableShop: React.PropTypes.bool,
    wmCartImageUrl: React.PropTypes.string,
    tsCartImageUrl: React.PropTypes.string,
    onBillBtnTap: React.PropTypes.func.isRequired,
    onCartIconTap: React.PropTypes.func.isRequired,
    isHDL: React.PropTypes.bool,
    // 满减信息
    multiMarketing: React.PropTypes.array,
  },
  getInitialState() {
    return {
      showToastMessage: false,
      toastMessage: '',
    };
  },
  componentWillReceiveProps(nextProps) {
    const { isHDL } = this.props;
    // 是海底捞的门店才执行以下逻辑
    if (isHDL) {
      const preCount = this.props.dishesCount || 0;
      const nextCount = nextProps.dishesCount || 0;
      // 当购买数量大于2时才触发
      if (preCount < nextCount && nextCount > 1) {
        this.showLimitMsg();
      }
    }
  },
  showLimitMsg() {
    // toast 提示  点击折扣商品时，toast提示“折扣商品每单限购1份，超出部分按原价购买”
    // 本次操作过程中是否已经显示了提示消息
    const hasShowMsg = JSON.parse(
      sessionStorage.getItem('has_show_discount_limit_msg') || false,
    );
    if (hasShowMsg) {
      return false;
    }
    const discountCount = this.checkDiscountNum();
    if (discountCount > 0) {
      // 是否还有满减优惠, 如果有提示: "满减与折扣/第二份半价商品不同享", 没有则提示: "折扣商品每单限购1份，超出部分按原价购买"
      const { multiMarketing } = this.props;
      let toastMessage =
        shoppingCartMessages.singleDiscountWithReduce.defaultMessage;
      if (multiMarketing && multiMarketing.length) {
        toastMessage =
          shoppingCartMessages.singleDiscountWithoutReduce.defaultMessage;
      }
      this.setState({
        showToastMessage: true,
        toastMessage,
      });
      sessionStorage.setItem('has_show_discount_limit_msg', true);
    }
  },
  checkDiscountNum() {
    // 检查打折商品的数量
    let discountCount = 0;
    const lastOrderedDishes = JSON.parse(
      localStorage.getItem('lastOrderedDishes') || '{}',
    );
    const dishes = lastOrderedDishes.dishes || [];
    dishes.forEach(item => {
      // marketingInfos 和 singleMarketingInfos 中都有折扣优惠信息
      const { marketingInfos = [], order, singleMarketingInfos = [] } = item;
      if (
        marketingInfos &&
        marketingInfos.length &&
        singleMarketingInfos &&
        singleMarketingInfos.length
      ) {
        if (typeof order === 'number') {
          discountCount += order;
        } else if (typeof order === 'object' && order instanceof Array) {
          // 含有子菜品的 order 是一个数组
          const count = order
            .map(orderItem => orderItem.count)
            .reduce((p, c) => p + c, 0);
          discountCount += count;
        }
      }
    });
    return discountCount;
  },
  clearToastMsg() {
    // 隐藏提示信息
    this.setState({ showToastMessage: false });
  },

  buildTakeawayServiceMinPriceElement(
    totalPrice,
    takeawayServiceProps,
    onBillBtnTap,
  ) {
    const { dishesCount, urlType, isAcceptOrder } = this.props;
    if (
      dishesCount > 0 &&
      (!takeawayServiceProps ||
        !takeawayServiceProps.minPrice ||
        totalPrice >= takeawayServiceProps.minPrice)
    ) {
      if (urlType === 'PD' || urlType === 'YD') {
        return (
          <BookButton
            type={urlType}
            dishesCount={dishesCount}
            isAcceptOrder={isAcceptOrder}
          />
        );
      }

      return (
        <a
          className="o-btn o-btn--linear tiny-cart-btn"
          onTouchTap={evt => {
            evt.preventDefault();
            onBillBtnTap();
          }}
        >
          <FormattedMessage {...shoppingCartMessages.closeOk} />
        </a>
      );
    } else if (
      dishesCount === 0 &&
      takeawayServiceProps &&
      takeawayServiceProps.minPrice
    ) {
      return (
        <span className="tiny-cart-text">
          <span className="price">{takeawayServiceProps.minPrice}</span>
          {formatMessage(shoppingCartMessages.tinyCartUpTo)}
          {sellType === 'ws'
            ? formatMessage(actionText3.orderActionDelivery)
            : formatMessage(actionText3.orderActionSell)}
        </span>
      );
    } else if (
      dishesCount > 0 &&
      takeawayServiceProps &&
      takeawayServiceProps.minPrice
    ) {
      return (
        <span className="tiny-cart-text">
          {formatMessage(orderText.less)}{' '}
          <span className="price">
            {formatPrice(takeawayServiceProps.minPrice - totalPrice)}
          </span>{' '}
          {formatMessage(shoppingCartMessages.tinyCartUpTo)}
          {sellType === 'ws'
            ? formatMessage(actionText3.orderActionDelivery)
            : formatMessage(actionText3.orderActionSell)}
        </span>
      );
    }

    return false;
  },
  /**
   * 计算外卖配送费
   * @param {*} totalPrice
   * @param {*} takeawayServiceProps
   */
  buildTakeawayServiceShipPriceElement(totalPrice, takeawayServiceProps) {
    if (!takeawayServiceProps || !takeawayServiceProps.shipmentFee) {
      return false;
    }

    const shipFreePrice = takeawayServiceProps.shipFreePrice; // 减免配送费金额
    const shipmentFee = takeawayServiceProps.shipmentFee; // 配送费金额
    const messageValues = {
      shipmentFee,
      currency: sessionStorage.getItem('currency'),
    };

    if (totalPrice < shipFreePrice) {
      return (
        <small className="o-fz--11 tiny-cart-small">
          <FormattedMessage
            {...shoppingCartMessages.needDeliveryFee}
            values={messageValues}
          />
        </small>
      );
    }

    return (
      <small className="o-fz--11 tiny-cart-small">
        <FormattedMessage
          {...shoppingCartMessages.freeDeliveryFee}
          values={messageValues}
        />
      </small>
    );
  },

  renderHDLPrivInfo(dishData) {
    const { singleMarketingInfos = [] } = dishData || {};
    const memberPrice = formatPrice(helper.getDishMemberPrice(dishData));
    const formateSingleMarketingInfos =
      singleMarketingInfos &&
      singleMarketingInfos.length > 0 &&
      singleMarketingInfos.map(info => {
        let reduceTotal = 0;
        switch (info.type) {
          case SiglePrivTypes.DISCOUNT:
            reduceTotal =
              dishData.isMember && memberPrice > 0
                ? memberPrice * (1 - info.value * 0.1)
                : dishData.marketPrice * (1 - info.value * 0.1);
            break;
          case SiglePrivTypes.REDUCE:
            reduceTotal = info.value;
            break;
          default:
            break;
        }

        return { ...info, reduceTotal };
      });

    const { reduceTotal } = []
      .concat(formateSingleMarketingInfos)
      .sort((a, b) => b.reduceTotal - a.reduceTotal)[0];

    return {
      reduceTotal,
      key: dishData.key,
    };
  },

  formatShowPrice(takeawayServiceShipPriceElement) {
    const {
      totalPrice,
      totalMemberPrice,
      isHDL,
      orderedDishes,
      isMember,
    } = this.props;
    const allowShowMemberPrice =
      totalPrice > totalMemberPrice && totalMemberPrice >= 0; // 是否满足展示条件
    const tmp = [];
    let tpPartStyle = {};
    let tmpPart = '';
    let tpPart = '';
    orderedDishes.map(item => {
      const reduceprice = this.renderHDLPrivInfo(item).reduceTotal || 0;
      if (reduceprice !== 0) {
        tmp.push({ reduceprice, key: item.id });
      }
      return tmp;
    });
    let max = (tmp[0] && tmp[0].reduceprice) || 0;
    let arr = [];
    for (let i = 0; i < tmp.length; i++) {
      if (tmp.length === 1) {
        max = tmp[0];
        arr = tmp[0];
      } else {
        if (typeof max === 'object') {
          if (max && max.reduceprice < (tmp[i + 1] && tmp[i + 1].reduceprice)) {
            max = tmp[i + 1];
            arr = tmp[i + 1];
          } else {
            arr = max;
          }
          // max = max && max.reduceprice < (tmp[i + 1] && tmp[i + 1].reduceprice) ? tmp[i + 1] : max;
          // arr = max && max.reduceprice < (tmp[i + 1] && tmp[i + 1].reduceprice) ? tmp[i + 1] : max;
        } else {
          if (max < (tmp[i + 1] && tmp[i + 1].reduceprice)) {
            max = tmp[i + 1];
            arr = tmp[i + 1];
          } else {
            max = tmp[i];
            arr = tmp[i];
          }
          // max = max < (tmp[i + 1] && tmp[i + 1].reduceprice) ? tmp[i + 1] : max;
          // arr = max < (tmp[i + 1] && tmp[i + 1].reduceprice) ? tmp[i + 1] : max;
        }
      }
    }
    const tmpReducePrice =
      typeof max !== 'number' ? formatPrice(max.reduceprice) : formatPrice(max);
    if (tmpReducePrice > 0) {
      sessionStorage.setItem('reducePrice', tmpReducePrice);
      sessionStorage.setItem('reducePriceKey', arr.key);
    }
    // sessionStorage.getItem('reducePrice') && sessionStorage.getItem('reducePriceNum') ? sessionStorage.getItem('reducePrice') : 0;
    const reducePrice = tmpReducePrice;
    if (isHDL) {
      tpPartStyle = {
        textDecoration: 'line-through',
        marginLeft: 8,
        color: '#999',
        fontSize: 14,
      };
      if (allowShowMemberPrice && isMember) {
        tmpPart = (
          <span className="price 1">
            <strong>{formatPrice(totalMemberPrice - reducePrice)}</strong>
          </span>
        );
        tpPart =
          reducePrice > 0 ? (
            <span className="price 2" style={tpPartStyle}>
              <strong>{formatPrice(totalMemberPrice)}</strong>
            </span>
          ) : (
            <span className="price 2" style={tpPartStyle}>
              <strong>{formatPrice(totalPrice)}</strong>
            </span>
          );
      } else {
        tmpPart = (
          <span className="price 3">
            <strong>{formatPrice(totalPrice - reducePrice)}</strong>
          </span>
        );
        tpPart = reducePrice > 0 && (
          <span className="price 4" style={tpPartStyle}>
            <strong>{formatPrice(totalPrice)}</strong>
          </span>
        );
      }
    } else {
      if (allowShowMemberPrice && isMember) {
        tpPartStyle = {
          textDecoration: 'line-through',
          marginLeft: 8,
          color: '#999',
          fontSize: 14,
        };
        tmpPart = (
          <span className="price">
            <strong>{formatPrice(totalMemberPrice)}</strong>
          </span>
        );
      }

      tpPart = (
        <span className="price" style={tpPartStyle}>
          <strong>{formatPrice(totalPrice)}</strong>
        </span>
      );
    }

    return (
      <div>
        <span
          className={classnames('o-fz--18 tiny-cart-price', {
            noShipmentFee: !takeawayServiceShipPriceElement,
          })}
        >
          {tmpPart}
          {tpPart}
        </span>
      </div>
    );
  },

  render() {
    const {
      expand,
      dishesCount,
      totalPrice,
      takeawayServiceProps,
      isShopOpen,
      urlType,
      wmCartImageUrl,
      tsCartImageUrl,
      isEnableShop,
      isAcceptOrder,
    } = this.props;
    const { onBillBtnTap, onCartIconTap, theme } = this.props;
    const { showToastMessage, toastMessage } = this.state;
    const takeawayServiceMinPriceElement = this.buildTakeawayServiceMinPriceElement(
      totalPrice,
      takeawayServiceProps,
      onBillBtnTap,
    );
    const takeawayServiceShipPriceElement = this.buildTakeawayServiceShipPriceElement(
      totalPrice,
      takeawayServiceProps,
    );
    const customCartImgIcon = HttpsProtocolImage.getFinalImageUrl(
      urlType === 'WM' ? wmCartImageUrl : tsCartImageUrl,
    );
    const industry = getIndustryFromBody();

    let buttonWord = '';
    if (!isEnableShop || !isAcceptOrder || !isShopOpen) {
      buttonWord = (
        <span className="tiny-cart-text">
          <FormattedMessage {...shoppingCartMessages.commercialClosed} />
        </span>
      );
    } else {
      buttonWord = takeawayServiceMinPriceElement;
    }

    const countStyle = dishesCount >= 10 ? { width: '25px' } : {};
    const formatShowPrice = this.formatShowPrice(
      takeawayServiceShipPriceElement,
    );

    const defaultCartIconImg =
      industry === INDUSTRY.TEA ? defaultCartIconTea : defaultCartIcon;
    const defaultCartIconHasImg =
      industry === INDUSTRY.TEA ? defaultCartIconHasTea : defaultCartIconHas;

    return (
      <div
        className={classnames('tiny-cart', {
          'tiny-cart-not-has': !dishesCount,
        })}
      >
        <div className="tiny-cart-left">
          <button
            className={classnames('cart-icon', {
              'cart-icon--linger': dishesCount,
              'cart-icon--modify': dishesCount > 99,
              'cart-icon--expand': expand && dishesCount !== 0,
              'cart-icon--tiny': !expand || dishesCount === 0,
              'cart-icon--custom': customCartImgIcon,
            })}
            onTouchTap={evt => onCartIconTap(dishesCount)}
            data-count={(dishesCount > 99 ? '99+' : dishesCount) || null}
          >
            {dishesCount > 0 && (
              <i
                className="cart-icon--counter counter-special"
                style={countStyle}
              >
                {(dishesCount > 99 ? '99+' : dishesCount) || null}
              </i>
            )}
            <img
              src={
                !dishesCount
                  ? customCartImgIcon || defaultCartIconImg
                  : customCartImgIcon || defaultCartIconHasImg
              }
              alt=""
            />
          </button>
          {dishesCount === 0 ? (
            <span className="tiny-cart-text">
              <FormattedMessage {...shoppingCartMessages.isEmpty} />
            </span>
          ) : (
            <div>
              {formatShowPrice}
              {takeawayServiceShipPriceElement}
            </div>
          )}
        </div>
        <div className="tiny-cart-right">{buttonWord}</div>
        {showToastMessage && (
          <Toast
            errorMessage={toastMessage}
            clearErrorMsg={() => {
              this.clearToastMsg();
            }}
            timeout={3000}
          />
        )}
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/dish-menu/cart/tiny-cart.jsx